(function(f){
    "use strict";

    "function"===typeof define&&define.amd?define(["exports"],f):"undefined"!==typeof module&&module.exports?module.exports=f():f();

})(function() {

    // UTILS
    function DrawSVGUtils() {}
    var dsvgu = DrawSVGUtils.prototype;

    DrawSVGUtils.mixin = function (target)
    {
        target.round = dsvgu.round;
        target.eraseStroke = dsvgu.eraseStroke;
        target.drawStroke = dsvgu.drawStroke;
        target.getLength = dsvgu.getLength;
        target.parseCubicBezierPoints = dsvgu.parseCubicBezierPoints;
        target.joinCubicBezierPoints = dsvgu.joinCubicBezierPoints;
        target.getTransitionalCubicBezierPoints = dsvgu.getTransitionalCubicBezierPoints;
        target.getTransitionalPoints = dsvgu.getTransitionalPoints;
    };

    dsvgu.round = function (val, n)
    {
        // For Chrome and IE:
        n = typeof n === "undefined" ? 2 : n;
        return parseFloat(val.toFixed(n));
    }

    dsvgu.eraseStroke = function (elems, length, direction, offset)
    {
        offset = offset || 0;
        direction = direction || 1;
        if (offset === 0)
            elems.attr({strokeDasharray: [0,length+1], strokeDashoffset: 1});
        else
            elems.attr({strokeDasharray: [0,length], strokeDashoffset: offset});

        return this;
    };

    dsvgu.drawStroke = function (elems, length, a, direction, offset)
    {
        offset = offset || 0;
        direction = direction || 1;
        a = typeof a === "undefined" ? 1 : a;

        if (a === 0){
            this.eraseStroke(elems, length, direction, offset);
            return;
        }

        var l = offset === 0 ? length+1 : length;
        if (direction < 0)
            elems.attr({strokeDasharray: [0, (1 - a) * l, a * l, 0]});
        else
            elems.attr({strokeDasharray: [a * l, (1 - a) * l]});
        return this;
    };

    dsvgu.getLength = function (elem)
    {
        var l;
        var x;
        var y;

        switch (elem.type.toLowerCase())
        {
            case "path":
                l = elem.getTotalLength();
                break;
            case "circle":
                l = parseFloat(elem.attr("r"));
                l = 2*Math.PI*l;
                break;
            case "polyline":
                l = _sum_(elem.attr("points"));
                break;
            case "polygon":
                l = _sum_(elem.attr("points"), true);
                break;
            case "line":
                x = elem.attr("x2") - elem.attr("x1");
                y = elem.attr("y2") - elem.attr("y1");
                if (isNaN(x) || isNaN(y)) return 0;
                l = Math.sqrt(x*x+y*y);
                break;
        }

        function _sum_(arr, close)
        {
            var x;
            var y;
            close = close || false;
            var i;
            var l = 0;
            for (i = 0; i < arr.length-2; i+=2)
            {
                x = arr[i+2]-arr[i];
                y = arr[i+3]-arr[i+1];
                if (isNaN(x) || isNaN(y)) break;
                l += Math.sqrt(x*x+y*y);
            }
            if (close)
            {
                x = arr[i]-arr[0];
                y = arr[i+1]-arr[1];
                if (!(isNaN(x) || isNaN(y)))
                    l += Math.sqrt(x*x+y*y);
            }
            return l;
        }

        return l;
    };

    dsvgu.parseCubicBezierPoints = function(path)
    {
        path = typeof path === "string" ? path : typeof path.attr === "undefined" ? "" : path.attr("path");
        if (path.length < 1) return [];
        var arr;
        var arri;
        var a = path.substr(0,1);
        var b;
        var c;
        var s = "";
        var i;
        var j;
        var zero;
        var z = path.substr(path.length-1,1);
        z = z.toLowerCase() === "z" ? "z" : "";
        // A start point of a path must be an absolute position.
        if (a !== "M") return [];
        a = path.substring(1).replace(/[\s\n\r\t\v\f]*c[\s\n\r\t\v\f]*/g, "c").replace(/[\s\n\r\t\v\f]*C[\s\n\r\t\v\f]*/g, "C").replace(/[\s\n\r\t\v\f]*-/g, "-").replace(/[\s]/g, ",").replace(/[\s\n\r\t\v\f]/g, "").replace(z,"");

        //var store = a;

        arr = [];
        zero = [];
        i = a.search(/[cC]/);
        j = a.search(/[,-]/);
        while (j > -1 && (j < i || i < 0))
        {
            c = a.substr(0, j);
            if (c.length > 0)
                zero.push(parseFloat(_getSign_(s) + c));
            s = a.substr(j, 1);
            a = a.substring(j+1);
            i -= j+1;
            j = a.search(/[,-]/);
        }
        zero.push(parseFloat(_getSign_(s) + (i > -1 ? a.substr(0, i) : a)));
        arr.push(zero);
        b = i > -1 ? a.substr(i, 1) : "";
        a = i > -1 ? a.substring(i + 1) : "";
        while (a.length > 0)
        {
            arri = [];
            arr.push(arri);
            s = "";
            i = a.search(/[cC]/);
            j = a.search(/[,-]/);
            while (j > -1 && (j < i || i < 0))
            {
                c = a.substr(0, j);
                if (c.length > 0)
                    arri.push(parseFloat(_getSign_(s) + c));
                s = a.substr(j, 1);
                a = a.substring(j+1);
                i -= j+1;
                j = a.search(/[,-]/);
            }
            arri.push(parseFloat(_getSign_(s) + (i > -1 ? a.substr(0, i) : a)));
            if (b === "c")
                for (j = 0; j < arri.length; j++)
                {
                    arri[j] = this.round(arri[j] + (j%2 === 0 ? zero[0] : zero[1]));
                }
            b = i > -1 ? a.substr(i, 1) : "";
            a = i > -1 ? a.substring(i + 1) : "";
            if (arri.length > 1)
                zero = arri.slice(arri.length-2, arri.length);
        }
        arr.push(z);

        function _getSign_(s)
        {
            return s === "-" ? s : "";
        }

        return arr;
    };

    dsvgu.joinCubicBezierPoints = function(arr)
    {
        var s = "M" + arr[0].join(",");
        var i;
        for (i = 1; i < arr.length; i++)
        {
            s += "C" + arr[i].join(",");
        }

        return s.replace(/,-/g, "-");
    };

    dsvgu.getTransitionalCubicBezierPoints = function(points0, points1, a, hasZ)
    {
        // Transition is focused on pathes consisted of the same number of segments
        if (points0.length !== points1.length) return null;

        hasZ = typeof hasZ === "undefined" ? true : hasZ;

        var arr = [];
        var arri;
        var pi0;
        var pi1;
        var j;
        var e = false;
        var n = hasZ ? points0.length-1 : points0.length;
        var i;
        for (i = 0; i < n; i++)
        {
            arri = [];
            pi0 = points0[i];
            pi1 = points1[i];
            arr.push(arri);
            if (pi0.length !== pi1.length)
            {
                e = true;
                break;
            }
            for (j = 0; j < pi0.length; j++)
            {
                arri.push(this.round(_getTransitionalValue_(parseFloat(pi0[j]), parseFloat(pi1[j]), a)));
            }
        }
        if (e) return null;

        if (hasZ)
            // "z"-parameter
            arr.push(a > 0.5 ? points1[points1.length-1] : points0[points0.length-1]);

        function _getTransitionalValue_(val0, val1, a)
        {
            return val0 + (val1 - val0) * a;
        }

        return arr;
    }

    dsvgu.getTransitionalPoints = function(points0, points1, a)
    {
        return this.getTransitionalCubicBezierPoints([points0], [points1], a, false);
    }


    return DrawSVGUtils;

});



// WEBPACK FOOTER //
// ./js/rrjs/utils/DrawSVGUtils.js